import styled from 'styled-components';
import { Panel } from 'rsuite';
import theme from '~/styles/theme';

export const IconWrapper = styled.div`
  width: 54px;

  height: 54px;

  border-radius: 12px;

  display:flex;

  align-items:center;

  justify-content:center;

  background:${props => props.background || '#EFF6FF'};
  color:${props => props.color || '#2563EB'};

  // color:white;

  font-size:24px;

  flex-shrink:0;
  svg {
    display: block;
    margin: 0;
  }
`;
